import React from 'react';

const ContentAbout = () => (
  <div className="main-content">
    <div className="about">
      <h2>About Me</h2>
      <p>
        Full-stack web developer based in Brooklyn, NY. Experienced with JavaScript (ES6), React, and Ruby on Rails. Passionate about writing clean, DRY code to build well-designed software that simplifies and enhances people&#39;s lives and jobs.
      </p>
      <p>
        Interested in working with me? I&#39;m seeking new opportunities, <a href="mailto:krandles@gmail.com" target="_blank" rel="noopener noreferrer">get in touch with me</a> and let&#39;s build something incredible.
      </p>
    </div>
  </div>
);

export default ContentAbout;



// WEBPACK FOOTER //
// ./src/components/ContentAbout.js